import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/CursorClick.es.js";
const r = o.forwardRef((c, e) => /* @__PURE__ */ o.createElement(s, { ref: e, ...c, weights: t }));
r.displayName = "CursorClickIcon";
const m = r;
export {
  m as CursorClick,
  r as CursorClickIcon
};
